export default "__VITE_ASSET__EjCnPXyT__"